function PollsPageSubmenu({ renderItems, translate }) {
  return renderItems([
    { label: translate('settings'), link: 'settings' },
    { label: translate('results'), link: 'results' },
  ]);
}

export default PollsPageSubmenu;
